export enum NavigatorPermissionStatus {
  'granted'= 'granted',
  'denied'= 'denied',
  'prompt'= 'prompt'
}